import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import App from './App';
import 'react-table/react-table.css';
import 'antd/lib/time-picker/style/index.css';
import './bulmaOverrides.scss';
import './index.scss';
import * as firebase from 'firebase/app';
import * as Sentry from '@sentry/browser';
import { ENVIRONMENT, RELEASE_STRING } from './constants';

Sentry.init({
  dsn: 'https://9487c91357ef448eb7c18dff23c9762b@sentry.io/1423577',
  environment: ENVIRONMENT,
  release: RELEASE_STRING,
});

firebase.initializeApp({
  apiKey: 'AIzaSyBKpcZw1JGJe8WlXwAHGTIge6RsDJE2qFM',
  authDomain: 'enrichment-tracking-app.firebaseapp.com',
  databaseURL: 'https://enrichment-tracking-app.firebaseio.com',
  storageBucket: 'enrichment-tracking-app.appspot.com',
  messagingSenderId: '158591886493',
});

// @ts-ignore
window.globals = {
  RELEASE_STRING,
};

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
